<div class="field-label" *ngIf="mode === 'normal'">
  <label
    *ngIf="labelKey"
    class="fz-14_lh-16"
    [ngClass]="{ oneline: labelOneLine }"
    [ngClass]="labelStyle"
    [pTooltip]="labelOneLine ? '{{label| translate}}' : ''"
    tooltipEvent="hover"
    tooltipPosition="top"
    >{{ labelKey | translate : param }}
    <span class="font-medium" *ngIf="currency"> ({{ currency }}) </span>
    <span *ngIf="!required && showOptionalText">
      ({{ 'OPTIONAL' | translate }})</span
    >
    <span class="asterisk" *ngIf="required">*</span>
    <i
      *ngIf="iconLabelTooltipKey"
      class="pi pi-info-circle ml-2"
      pTooltip="{{ iconLabelTooltipKey | translate : iconLabelTooltipParam }}"
      tooltipEvent="hover"
      tooltipPosition="top"
    ></i>
  </label>
</div>

<div class="field-error" *ngIf="mode === 'error'">
  <div class="error-message fz-14_lh-16">
    {{ labelKey | translate : param }}
  </div>
</div>
